import { ScrollFade, Text } from 'components';
import { PlusIcon } from 'assets/svgs';
import { SpacecraftItem, SpacecraftListResponse } from 'pages/Dashboard/types';
import { useEffect, useState } from 'react';
import axios from 'common/AxiosAuth';
import { useNavigate } from 'react-router-dom';

export const SpacecraftCardList = () => {
  const [data, setData] = useState<SpacecraftItem[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get<SpacecraftListResponse>('/api/dashboard/spacecraft')
      .then((res) => setData(res.data.data))
      .catch((err) => console.error('위성 데이터 조회 실패', err));
  }, []);

  const handleAddClick = () => {
    // 기존 위성 관리 페이지로 이동
    navigate('/manage-spacecraft');
  };

  // 랜더링 순서
  const orderedKeys: (keyof SpacecraftItem)[] = [
    'name',
    'noradId',
    'tleTitle',
    'direction',
    'band',
    'centerFrequency',
    'tleUpdate'
  ];

  return (
    <div className="space-y-2">
      <ScrollFade className="items-stretch gap-3">
        {data.length === 0 ? (
          <div className="min-w-80 rounded-xl border border-border-primary bg-bg-layer3 p-4">
            <div className="mb-4 flex items-center justify-between">
              <Text size="body2" weight="semibold" color="primary">
                Spacecraft
              </Text>
            </div>
            <div className="mb-4 border-b border-border-primary" />
            <div className="text-sm text-secondary text-center py-12">
              No registered spacecraft available.
            </div>
          </div>
        ) : (
          data.map((spacecraft, index) => (
            <div
              key={index}
              className="min-w-80 rounded-xl border border-border-primary bg-bg-layer3 p-4"
            >
              <div className="mb-4 flex items-center justify-between">
                <Text size="body2" weight="semibold" color="primary">
                  {spacecraft.name}
                </Text>
              </div>
              <div className="mb-4 border-b border-border-primary" />

              <div className="space-y-3">
                {orderedKeys
                  .filter(key => !['name', 'centerFrequency'].includes(key))
                  .map((key) => {
                  const value = spacecraft[key];
                  const label = key
                    .replace(/([A-Z])/g, ' $1')
                    .replace(/^./, (str) => str.toUpperCase());

                  return (
                    <div key={key} className="flex gap-3">
                      <Text size="body2" weight="medium" color="secondary" className="w-32">
                        {label}
                      </Text>
                      <Text size="body2" weight="regular" color="secondary" className="text-nowrap">
                        {String(value)}
                      </Text>
                    </div>
                  );
                })}
              </div>
            </div>
          ))
        )}

        {/* 추가 버튼 */}
        <div 
          className="flex min-w-20 cursor-pointer items-center justify-center rounded-xl border-2 border-dashed border-system100 transition-all hover:bg-system100/10 active:scale-95"
          onClick={handleAddClick}
        >
          <PlusIcon className="h-5 w-5 [&_path]:fill-[#0766F3]" />
        </div>
      </ScrollFade>
    </div>
  );
};
